import { AssignmentsFilter } from '../models';
import { useGetAssignmentsQuery } from '../service/inventoryAssignments.service';

interface UseAssignmentsProps {
  filters?: AssignmentsFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useAssignments = ({ filters, paginated }: UseAssignmentsProps) => {
  const {
    data: assignments,
    isLoading: isAssignmentsLoading,
    error,
  } = useGetAssignmentsQuery({ filters, paginated });

  return {
    assignments: assignments?.items || [],
    totalItems: assignments?.count || [].length,
    totalPages: assignments?.count
      ? Math.ceil(assignments.count / paginated.pageSize)
      : 0,
    isAssignmentsLoading,
    error,
  };
};

export default useAssignments;
